import React from "react";
import AccordionReferralCard from "components/card/AccordionReferralCard";
import {
  EntityType,
  Referral,
  Asset,
  AssetReferralActionStatusEnum,
} from "types";
import AssetList from "pages/AssetRecovery/Assets/AssetList";

interface AssetCardProps {
  referralData?: Referral | null;
  referralId?: string;
  handleButtonClick: (type: EntityType) => void;
  handleEdit: (type: EntityType, evidence: Asset) => void;
  fileRowProps: any;
  handleAssetCreated: () => void;
  setActiveTab?: React.Dispatch<React.SetStateAction<string>>;
  reports: any;
  recoveryReports: any;
  // New props for popup triggers
  onAddGovernance?: (asset: Asset) => void;
  onEditGovernance?: (asset: Asset) => void;
  onAddProvision?: (asset: Asset) => void;
  setIsAssetPopupOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleOpenAssetDetail: (asset: Asset) => void;
}

export default function AssetCard({
  referralData,
  referralId,
  handleButtonClick,
  handleEdit,
  fileRowProps,
  recoveryReports,
  reports,
  handleAssetCreated,
  setActiveTab,
  onAddGovernance,
  onEditGovernance,
  onAddProvision,
  setIsAssetPopupOpen,
  handleOpenAssetDetail,
}: AssetCardProps) {
  return (
    <AccordionReferralCard
      title={`Assets - ${referralData?.assets?.length || 0}`}
      buttonText="Add Asset"
      onButtonClick={() => setIsAssetPopupOpen(true)}
      // disabled={
      //   ![
      //     AssetReferralActionStatusEnum.PENDING,
      //     // AssetReferralActionStatusEnum.INVESTIGATION_ONGOING,
      //   ].includes(referralData?.action_status as AssetReferralActionStatusEnum)
      // }
    >
      <AssetList
        referralId={referralId as string}
        referral={referralData as Referral}
        onAssetCreated={handleAssetCreated}
        setActiveTab={setActiveTab}
        reports={reports}
        recoveryReports={recoveryReports}
        onAddGovernance={onAddGovernance}
        onEditGovernance={onEditGovernance}
        onAddProvision={onAddProvision}
        handleOpenAssetDetail={handleOpenAssetDetail}
      />
    </AccordionReferralCard>
  );
}
